const areas = {
  headerButtons: {
    create: {
      createBtn: 'Erstellen',
    },

    import: 'Importieren',
  },
  table: {
    headers: {
      name: 'Name',
      type: 'Typ',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  toast: {
    error: {
      badResponse: '[Zone] Ungültige Serverantwort',
      create: {},
      edit: {},
      delete: '[Zone] Konnte nicht gelöscht werden',
    },
    success: {
      create: {
        default: 'Zone erfolgreich erstellt',
      },
      edit: {},
      delete: {
        default: 'Zonen wurden erfolgreich gelöscht',
      },
    },
  },
  create: {
    createBtn: 'Neu',
    successToast: {
      message: 'Erfolg! Zone erstellt',
    },
    errorToast: {
      message: 'Fehler aufgetreten! Zone konnte nicht erstellt werden',
      duplicateMessage: 'Eine Zone mit dem gewählten Namen existiert bereits'
    },
    validations: {
      name: 'Name ist erforderlich',
      type: 'Typ ist erforderlich',
      siteId: 'Site-ID ist erforderlich',
    },
  },
  delete: {
    deleteBtn: 'Löschen',
    deleteModal: {
      header: 'Zonen löschen?',
      body: 'Sie sind dabei, {{number}} Zonen zu löschen',
    },
    successToast: {
      message: 'Erfolgreich gelöscht!',
    },
    errorToast: {
      message: 'Fehler aufgetreten! Zone konnte nicht gelöscht werden',
    },
  },
  update: {
    successToast: {
      message: 'Erfolg! Zonen-Aktualisierung',
    },
    errorToast: {
      message: 'Fehler aufgetreten! Zone konnte nicht aktualisiert werden',
    },
    validations: {
      name: 'Name ist erforderlich',
      type: 'Typ ist erforderlich',
    },
  },
  forms: {
    tabs: {
      general: 'Allgemein',
      advancedSettings: 'Erweiterte Einstellungen',
    },

    header: {
      createArea: {
        title: 'Erstellen',
      },

      updateArea: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      details: {
        header: 'Details',
        fields: {
          showOtherAreas: 'Andere Zonen anzeigen',
          name: 'Name',
          type: 'Typ',
        },
      },
      map: {
        header: 'Karte',
      },
      settings: {
        btnAdd: 'Hinzufügen',
        header: 'Verhältnis',
        label: 'Wählen Sie Verhältniszonen',
        notice: 'Verhältnisse, die "Alle" enthalten, sind allen Zonen zugeordnet und können in allen Zonen bearbeitet werden.',
        headerAreaRestrictions: 'Zonenbeschränkungen',
        titleAreaRestrictions: 'Blockaktionen',
      },
      advancedSettings: {
        consistentPassengerRouting: {
          title: 'Consistent Passenger Routing',
          toolTipInformation:
            'Ensures that the same group of passengers always follows the same route to and from the zone, optimizing travel efficiency and minimizing confusion.',
        },
        sameDriverForGroup: {
          title: 'Same Driver for Group',
          toolTipInformation:
            'Assigns the same driver to transport the group of passengers for both pick-up and drop-off, providing familiarity and consistency for passengers.',
        },
        overrideOptions: {
          bySystemSettings: 'By System Settings',
          enabled: 'Enabled',
          disabled: 'Disabled',
        },
        tripBoardingTime: {
          title: 'Einstiegszeit',
          toolTipInformation:
            'Die Zeit, die benötigt wird, um einen Fahrgast an seiner Haltestelle aufzunehmen (Dieser Parameter beeinflusst die Gesamtdauer der Fahrt)',
        },
        waitForBoardingTime: {
          title: 'Wartezeit für Einstieg',
          toolTipInformation: 'Beim Erreichen einer Haltestelle wartet der Fahrer bis zur genauen Abholzeit, falls erforderlich.',
        },
        tripDropOffTime: {
          title: 'Ausstiegszeit',
          toolTipInformation:
            'Die Zeit, die benötigt wird, um einen Fahrgast an seiner Haltestelle abzusetzen (Dieser Parameter beeinflusst die Gesamtdauer der Fahrt)',
        },
        maxDropOffEarly: {
          title: 'Max. frühes Absetzen',
          toolTipInformation:
            'Maximale Anzahl von Minuten, die ein Fahrer im Vergleich zur in der Reservierung festgelegten Absetzzeit zu früh sein darf',
        },
        maxDropOffDelay: {
          title: 'Max. Absetzverspätung',
          toolTipInformation:
            'Maximale Anzahl von Minuten, die ein Fahrer im Vergleich zur in der Reservierung festgelegten Absetzzeit zu spät sein darf',
        },
        maxBoardingDelay: {
          title: 'Max. Einstiegsverspätung',
          toolTipInformation:
            'Maximale Anzahl von Minuten, die ein Fahrer im Vergleich zur in der Reservierung festgelegten Abholzeit zu spät sein darf',
        },
        maxBoardingEarly: {
          title: 'Max. früher Einstieg',
          toolTipInformation:
            'Maximale Anzahl von Minuten, die ein Fahrer im Vergleich zur in der Reservierung festgelegten Abholzeit zu früh sein darf',
        },
        maxTripDuration: {
          title: 'Max. Fahrtdauer',
          toolTipInformation: 'Maximale Dauer einer Fahrt in Minuten',
        },
        maxSinglePassengerTime: {
          title: 'Max. Einzelfahrgast-Fahrtdauer',
          toolTipInformation: 'Maximale Dauer einer Fahrt in Minuten pro Fahrgast',
        },
      },
    },
  },

  polygoneTypes: {
    operationalArea: 'Betriebszone',
    fares: 'Tarife',
    routes: 'Routen',
    block: 'Block',
    restriction: 'Routing/Zuweisen',
  },

  blockActions: {
    createRideSharing: 'Fahrt erstellen',
    assignDrivers: 'Fahrer zuweisen',
    createRideSharingAndAssignDrivers: 'Fahrt erstellen und Fahrer zuweisen',
  }
};

export default areas;
